import React from "react";
import "./For_Citizens.css";

const For_Citizens = () => {
  return (
    <section className="For_Citizens">
      <div className="container">
        <div className="row align-items-center">
          {/* Image Column */}
          <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
            <div className="citizens-image">
              <img
                src="/assets/images/home/for_citizens/img2.png"
                alt="Everyday City Life"
                className="img-fluid"
              />
            </div>
          </div>

          {/* Content Column */}
          <div className="col-lg-6 col-md-12">
            <div className="citizens-content">
              <h2 className="section-title">Built for Everyday City Life</h2>

              <ul className="citizens-list">
                <li>Find products near you</li>
                <li>Access emergency numbers instantly</li>
                <li>Connect with trusted local experts</li>
                <li>Discover city services</li>
                <li>Save time searching</li>
                <li>Support local economy</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default For_Citizens;
